import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { useGetPageMode } from '@confluence/page-utils/entry-points/useGetPageMode.ts';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';

/**
 * Coarse *context* eligibility for the OnCriteria Content Reviewer path: Rovo is available, the user
 * has not already seen the nudge, and the page is edit or live (view can be added here later).
 *
 * This is the base gate only — the actual criteria matching (content-state transition, word count)
 * lives in `useContentReviewerNudgeOnCriteria`. It is also consumed independently to decide whether
 * to fetch the content fragment. Do not use it from `useContentReviewerNudgeAction`; an OnPublish
 * path will have its own context eligibility.
 */
export const useContentReviewerNudgeOnCriteriaBaseEligibility = (): boolean => {
	const { isRovoLLMEnabled } = useSessionData();
	const pageMode = useGetPageMode();
	const hasUserSeenNudge = confluenceLocalStorageInstance.getItemAsBoolean(
		keys.AUTOMATION_DISCOVER_CONTENT_REVIEWER,
	);

	return (
		!hasUserSeenNudge &&
		isRovoLLMEnabled &&
		(pageMode === PageMode.EDIT || pageMode === PageMode.LIVE)
	);
};
